import { render } from "./StripeAndPaymentIntegration.vue?vue&type=template&id=b13aeb12&scoped=true"
import script from "./StripeAndPaymentIntegration.vue?vue&type=script&lang=js"
export * from "./StripeAndPaymentIntegration.vue?vue&type=script&lang=js"

import "./StripeAndPaymentIntegration.vue?vue&type=style&index=0&id=b13aeb12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13aeb12"]])

export default __exports__